<template>
    <div class="page">
      <v-container fluid>
        <v-row justify="center">
          <v-col cols="12" md="8" lg="8" xl="8">
            <v-card rounded="lg">
              <v-tabs v-model="form.tab" centered>
                <v-tabs-slider />
              </v-tabs>
              <v-tabs-items v-model="form.tab">
                <v-form ref="form" v-model="form.valid" class="px-10" autocomplete="off">
                  <v-tab-item value="tab-dados-cadastrais" eager>
                    <v-container>
                        <v-row>
                            <v-col cols="7" class="d-flex align-center">
                                <v-text-field
                                label="Nome"
                                v-model="dados.nome"
                                maxlength="80"
                                outlined
                                dense
                                :rules="[$required]"
                                :disabled="dados.tipoUsuario === TipoUsuarioEnum.INTERNO"
                                />
                            </v-col>
                            <v-col cols="5" class="d-flex align-center margin-top-negative">
                                <v-checkbox
                                    v-model="dados.inserirNomeSocial"
                                    dense
                                >
                                    <template v-slot:label>
                                        Inserir Nome Social
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon right v-bind="attrs" v-on="on" @click.stop>mdi-chat-question-outline</v-icon>
                                            </template>
                                            <span class="custom-tooltip">
                                                Nome social é a designação pela qual a pessoa travesti ou transexual se identifica<br>
                                                e é socialmente reconhecida e deverá ser composto por prenome, acrescido do(s)<br>
                                                sobrenome(s) familiar(es) constante(s) do nome civil, não podendo ser irreverente<br>
                                                ou atentar contra o pudor.
                                            </span>
                                        </v-tooltip>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row v-if="dados.inserirNomeSocial">
                            <v-col cols="12">
                            <v-text-field
                                label="Nome Social"
                                v-model="dados.nomeSocial"
                                outlined
                                maxlength="80"
                                counter="80"
                                dense
                                :rules="[$required]"
                            />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4">
                                <v-text-field
                                    label="CPF"
                                    v-model="dados.cpf"
                                    v-mask="'###.###.###-##'"
                                    outlined
                                    dense
                                    disabled
                                ></v-text-field>
                            </v-col>
                            <v-col cols="8">
                                <v-text-field
                                    label="E-mail"
                                    v-model="dados.email"
                                    outlined
                                    dense
                                    disabled
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="E-mail Secundário"
                                    v-model="dados.emailSecundario"
                                    maxlength="100"
                                    counter="100"
                                    outlined
                                    dense
                                    :rules="[(v) => $emailNotRequired(v)]"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    label="Telefone*"
                                    v-mask="'(##) #####-####'"
                                    hint="Número de preferência que seja WhatsApp"
                                    v-model="dados.telefone"
                                    hide-details="auto"
                                    maxlength="15"
                                    dense
                                    outlined
                                    @input="$formatarTelefone"
                                    :rules="[$required, $validarDDD]"
                                    />
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete
                                    v-model="dados.origemId"
                                    label="Origem*"
                                    dense
                                    outlined
                                    :items="origens"
                                    item-text="nome"
                                    item-value="id"
                                    :rules="[$required]"
                                    @change="verificarOrigemSelecionada"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" v-if="mostrarNomeGre">
                                <v-autocomplete
                                    v-model="dados.greId"
                                    label="Nome da GRE*"
                                    dense
                                    outlined
                                    item-text="nome"
                                    item-value="codigo"
                                    return-object
                                    :items="listaGerenciasRegionais"
                                    :rules="[$required]"
                                />
                            </v-col>
                            <v-col cols="12" v-if="mostrarSecretariaExecutiva">
                                <v-autocomplete
                                    v-model="dados.secretariaId"
                                    label="Secretaria Executiva*"
                                    dense
                                    outlined
                                    :items="listaSecretarias"
                                    item-text="nome"
                                    item-value="codigo"
                                    return-object
                                    :rules="[$required]"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-autocomplete
                                    v-model="dados.funcaoId"
                                    label="Função*"
                                    dense
                                    outlined
                                    :items="listaFuncoes"
                                    item-text="nome"
                                    item-value="id"
                                    :rules="[$required]"
                                    @change="atualizarCamposPorFuncao"
                                />
                            </v-col>
                            <v-col cols="6" v-if="!mostrarDisciplina">
                                <v-autocomplete
                                    v-model="dados.setorId"
                                    label="Setor*"
                                    dense
                                    outlined
                                    :items="listaSetores"
                                    item-text="nome"
                                    item-value="id"
                                    :rules="[$required]"
                                />
                            </v-col>
                            <v-col v-else cols="6">
                                <v-autocomplete
                                    v-model="dados.disciplinaId"
                                    label="Disciplina*"
                                    dense
                                    outlined
                                    :items="listaDisciplinas"
                                    item-text="nome"
                                    item-value="id"
                                    return-object
                                    :rules="[$required]"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                  </v-tab-item>
                </v-form>
              </v-tabs-items>
              <sigfoco-buttons
                @click="atualizarDadosDoProfissional"
                @cancel="cancelar"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </template>

<script>
import ManterFuncaoService from "~/services/manter-funcao.service";
import ManterSetorService from "~/services/manter-setor.service";
import ManterAtualizacaoCadastralService from "~/services/atualizacao-cadastral.service";
import { AUTH_NAMESPACE, USER, LOGIN, } from 'store/modules/auth';
import TipoUsuarioEnum from '~/commons/enums/tipo-usuario.enum';
export default {
    name: "ManterAtualizacaoCadastralView",
    mixins: [ManterFuncaoService, ManterSetorService, ManterAtualizacaoCadastralService],
    props: {
        origens: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        form: {
            valid: false,
            tab: "tab-dados-cadastrais",
        },
        isSecretaria: false,
        dados: {
            nome: null,
            nomeSocial: null,
            cpf: null,
            email: null,
            emailSecundario: null,
            telefone: null,
            origemId: null,
            greId: null,
            secretariaId: null,
            funcaoId: null,
            setorId: null,
            disciplinaId: null,
        },
        origens: [],
        listaFuncoes: [],
        listaSetores: [],
        listaGerenciasRegionais: [],
        listaSecretarias: [],
        mostrarDisciplina: false,
        mostrarNomeGre: false,
        mostrarSecretariaExecutiva: false,
        isLoadingSetores: false,
        ultimaOrigemSetoresCarregada: null,
        TipoUsuarioEnum
    }),
    watch: {
        'dados.inserirNomeSocial'(newValue) {
            if (!newValue) {
                this.dados.nomeSocial = null;
            }
        },
    },
    computed: {
      user() {
        return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
      }
    },
    methods: {
        cancelar() {
            this.$router.push('/app').catch(() => {});
        },
        montarDadosUsuario(usuario) {
            this.dados = {
                id: usuario?.id || null,
                nome: usuario?.nome || null,
                cpf: this.$user.username || null,
                email: usuario?.email || null,
                nomeSocial: usuario?.nomeSocial || null,
                emailSecundario: usuario?.emailSecundario || null,
                telefone: usuario?.telefone || null,
                origemId: usuario?.origemId || null,
                greId: usuario?.greId ? { codigo: usuario.greId, nome: usuario.gre } : null,
                secretariaId: usuario?.secretariaId
                ? { codigo: usuario.secretariaId, nome: usuario.secretaria }
                : null,
                funcaoId: usuario?.funcaoId || null,
                setorId: usuario?.setorId || null,
                disciplinaId: usuario?.disciplinaId || null,
                inserirNomeSocial: usuario?.inserirNomeSocial || false,
                tipoUsuario: usuario?.tipoUsuario || null,
            };
            this.verificarOrigemSelecionada();
            this.atualizarCamposPorFuncao();
        },

        atualizarCamposPorFuncao() {
            const funcaoSelecionada = this.listaFuncoes.find(funcao => funcao.id === this.dados.funcaoId);
            if (funcaoSelecionada && funcaoSelecionada.nome === "Professor") {
                this.mostrarDisciplina = true;
                this.dados.setorId = null;
            } else {
                this.mostrarDisciplina = false;
                this.disciplinaId = null;
            }
        },

        async verificarOrigemSelecionada() {
            this.mostrarNomeGre = false;
            this.mostrarSecretariaExecutiva = false;

            const origemSelecionada = this.dados.origemId;

            if (origemSelecionada) {
                const origem = this.origens.find(o => o.id === origemSelecionada);
                
                if (origem) {
                    const nomeOrigem = origem.nome.toUpperCase();
                    if (nomeOrigem === 'GRE' || nomeOrigem === 'ESCOLA') {
                        this.mostrarNomeGre = true;
                    } else if (nomeOrigem === 'SEE') {
                        this.mostrarSecretariaExecutiva = true;
                    }
                }
            }
            if (!this.mostrarNomeGre) this.dados.greId = null;
            if (!this.mostrarSecretariaExecutiva) this.dados.secretariaId = null;

            if (!origemSelecionada) {
                this.listaSetores = [];
                this.ultimaOrigemSetoresCarregada = null;
                this.isSecretaria = this.mostrarSecretariaExecutiva;
                return;
            }

            if (
                this.ultimaOrigemSetoresCarregada === origemSelecionada ||
                this.isLoadingSetores
            ) {
                this.isSecretaria = this.mostrarSecretariaExecutiva;
                return;
            }

            this.isLoadingSetores = true;
            try {
                const params = { params: { origem: origemSelecionada } };
                const { data } = await this.$buscarSetores(params);
                this.listaSetores = data.itens;
                this.ultimaOrigemSetoresCarregada = origemSelecionada;
            } finally {
                this.isLoadingSetores = false;
            }

            this.isSecretaria = this.mostrarSecretariaExecutiva;
        },

        atualizarDadosDoProfissional() {
            const save = () => {
                const dadosParaEnvio = {
                    nome: this.dados.nome,
                    nomeSocial: this.dados.nomeSocial,
                    cpf: this.dados.cpf ? this.dados.cpf.replace(/\D/g, '') : null,
                    emailSecundario: this.dados.emailSecundario,
                    telefone: this.dados.telefone ? this.dados.telefone.replace(/\D/g, '') : null,
                    origemId: this.dados.origemId,
                    funcaoId: this.dados.funcaoId,
                    setorId: this.dados.setorId,
                    disciplinaId: this.dados.disciplinaId?.id ?? this.dados.disciplinaId,
                    isSecretaria: this.isSecretaria,
                    
                };
                if (this.isSecretaria) {
                    dadosParaEnvio.secretariaId = this.dados.secretariaId?.codigo;
                    dadosParaEnvio.secretaria = this.dados.secretariaId?.nome;
                } else {
                    dadosParaEnvio.gre = this.dados.greId?.nome;
                    dadosParaEnvio.greId = this.dados.greId?.codigo;
                }
                return this.$swal({
                text: `Deseja Confirmar essa Operação?`,
                type: "warning",
                showCancelButton: true,
                confirmButtonText: `Confirmar`,
                cancelButtonText: `Cancelar`,
                }).then(() => {
                  return this.$cadastrarAtualizacaoCadastral(dadosParaEnvio)
                    .then(() => this.$renovarToken().then(({ data }) => {
                      if (data.sucesso) {
                        this[LOGIN](data);
                        this.$toHome();
                        this.$notifySuccess("Operação realizada com sucesso.");
                      }}));
                });
            };

            if (this.$validarFormulario("Preencha todos os campos obrigatórios!")) {
                save().then(({ data }) => {
                this.$notifySuccess(data.mensagem);
                this.$emit("onClose");
                this.$emit("onSave");
                this.$router.push('/app').catch(() => {});
                
                });
            }
        }
    },
    async mounted() {
        const cpf = this.$user.username;

        // Carrega de forma sequencial para evitar burst de requisições no backend.
        const { data: origemData } = await this.$buscarOrigens();
        this.origens = origemData.itens;

        const { data: funcoesData } = await this.$buscarFuncoes({ origem: null });
        this.listaFuncoes = funcoesData.itens;

        const { data: participanteData } = await this.$buscarParticipante(cpf);
        this.montarDadosUsuario(participanteData.resposta);

        await this.verificarOrigemSelecionada();
        this.atualizarCamposPorFuncao();

        if (this.mostrarNomeGre || this.dados.greId) {
            const { data } = await this.$obterListaGerenciasRegionais();
            this.listaGerenciasRegionais = data.lista;
        }

        if (this.mostrarSecretariaExecutiva || this.dados.secretariaId) {
            const { data } = await this.$obterListaSecretarias();
            this.listaSecretarias = data.lista;
        }

        if (this.mostrarDisciplina || this.dados.disciplinaId) {
            const { data } = await this.$buscarDisciplina();
            this.listaDisciplinas = data.lista;
        }
    },
};
</script>
<style scoped>
.margin-top-negative {
    margin-top: -13px;
}
</style>